<template>
  <div>
    <div>
      <classenv
        :low="cla_env_low"
        :upp="cla_env_hig"
        :tec="cla_env_tec"
        :type_code="type_code"
        :tecOnOff="tecOnOff"
        :title="title[1]"
      />
    </div>
    <div>
      <classsec :data="mate" :type_code="type_code" :title="title[2]" />
    </div>
    <div v-if="true">
      <classtec :data="m_tec" :type_code="type_code" :title="title[3]" />
    </div>
  </div>
</template>

<script>
import classEnvSec from "@/components/ascf/sec/classEnvSec.vue";
import classSec from "@/components/ascf/sec/classSec.vue";
import classTec from "@/components/ascf/sec/classTec.vue";
export default {
  props: ["title", "cla_env_low", "cla_env_hig", "cla_env_tec", "mate", "m_tec", "type_code", "tecOnOff"],
  components: {
    classsec: classSec,
    classenv: classEnvSec,
    classtec: classTec
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
</style>